export const clients = [
  {
    id: 1,
    company: "名古屋水道設備株式会社",
    industry: "設備工事",
    contractDate: "2025-04-01",
    status: "active",
    revenue: 8200000,
  },
  {
    id: 2,
    company: "東海管工業株式会社",
    industry: "設備工事",
    contractDate: "2025-06-15",
    status: "active",
    revenue: 5400000,
  },
  {
    id: 3,
    company: "中部設備メンテナンス",
    industry: "設備工事",
    contractDate: "2025-09-01",
    status: "active",
    revenue: 7800000,
  },
  {
    id: 4,
    company: "愛知給排水工業",
    industry: "設備工事",
    contractDate: "2025-11-20",
    status: "trial",
    revenue: 2100000,
  },
  {
    id: 5,
    company: "東海ビル管理株式会社",
    industry: "ビル管理",
    contractDate: "2025-03-10",
    status: "active",
    revenue: 4600000,
  },
  {
    id: 6,
    company: "名古屋建設コンサルティング",
    industry: "建設コンサル",
    contractDate: "2025-12-01",
    status: "negotiating",
    revenue: 0,
  },
];

export const monthlyRevenue = [
  { month: "1月", revenue: 7200000, target: 8000000 },
  { month: "2月", revenue: 6800000, target: 8000000 },
  { month: "3月", revenue: 9500000, target: 8000000 },
  { month: "4月", revenue: 8400000, target: 8000000 },
  { month: "5月", revenue: 7900000, target: 8000000 },
  { month: "6月", revenue: 8600000, target: 8000000 },
  { month: "7月", revenue: 7500000, target: 8000000 },
  { month: "8月", revenue: 6900000, target: 8000000 },
  { month: "9月", revenue: 8800000, target: 8000000 },
  { month: "10月", revenue: 9200000, target: 8000000 },
  { month: "11月", revenue: 8100000, target: 8000000 },
  { month: "12月", revenue: 10500000, target: 8000000 },
];

export const tasks = {
  todo: [
    { id: "t1", title: "本社ビル1F 配管改修工事 現場確認", priority: "high", due: "2026-06-10", client: "名古屋水道設備" },
    { id: "t2", title: "第3四半期 定期点検スケジュール策定", priority: "medium", due: "2026-06-15", client: "名古屋水道設備" },
    { id: "t3", title: "配管老朽化診断レポート作成", priority: "low", due: "2026-06-20", client: "東海管工業" },
  ],
  inProgress: [
    { id: "t4", title: "緊急修理対応 — 2F給水管漏水", priority: "high", due: "2026-06-05", client: "名古屋水道設備" },
    { id: "t5", title: "定期点検 — ポンプ設備点検（月次）", priority: "medium", due: "2026-06-08", client: "名古屋水道設備" },
    { id: "t6", title: "中部設備メンテナンス 保守契約更新交渉", priority: "medium", due: "2026-06-07", client: "中部設備メンテナンス" },
  ],
  done: [
    { id: "t7", title: "本社ビル 排水管高圧洗浄完了", priority: "high", due: "2026-05-30", client: "名古屋水道設備" },
    { id: "t8", title: "愛知給排水工業 トライアル初回ヒアリング", priority: "medium", due: "2026-05-28", client: "愛知給排水工業" },
    { id: "t9", title: "5月度 施工実績レポート提出", priority: "low", due: "2026-05-25", client: "-" },
  ],
};

export const aiEffects = [
  {
    id: 1,
    label: "点検工数削減率",
    value: "54%",
    description: "AI診断による現場作業効率化",
    icon: "clock",
    trend: "+11%",
    trendUp: true,
  },
  {
    id: 2,
    label: "緊急修理コスト削減",
    value: "¥12.6M",
    description: "予防保全導入による年間削減額",
    icon: "yen",
    trend: "+18%",
    trendUp: true,
  },
  {
    id: 3,
    label: "漏水検知精度",
    value: "91%",
    description: "AIセンサー解析による早期検知",
    icon: "shield",
    trend: "+7%",
    trendUp: true,
  },
  {
    id: 4,
    label: "顧客満足度スコア",
    value: "4.7/5",
    description: "直近四半期の平均評価",
    icon: "star",
    trend: "+0.4",
    trendUp: true,
  },
];
